import { Anulicense } from '../license';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import './heroSection.css';

const heroSlides = [
  {
    image: Anulicense.banner_1,
    alt: 'Banner 1',
  },
  {
    image: Anulicense.banner_2,
    alt: 'Banner 2',
  },
  {
    image: Anulicense.banner_3,
    alt: 'Banner 3',
  },
  {
    image: Anulicense.banner_4,
    alt: 'Banner 4',
  },
];

const HeroSection = () => {
  return (
    <div className="anuHero w-full">
      <Swiper
        modules={[Navigation, Autoplay]}
        navigation
        autoplay={{ delay: 4000, disableOnInteraction: false }}
        loop={true}
        className="hero-swiper w-full responsive-hero-height"
      >
        {heroSlides.map((slide, idx) => (
          <SwiperSlide key={idx}>
            <div
              className="relative w-full h-full"
              style={{
                backgroundImage: `url(${slide.image})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                width: '100%',
                height: '100%',
              }}
            >
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default HeroSection;
